module.exports = __webpack_public_path__ + "img/Ic_WeChat.d8aa256a.svg";